import { spawn, call, takeLatest, put, all } from 'redux-saga/effects';

// Actions
import { revokeTokenAction } from '../../../../application/actions/revokeToken';
import { loadersActions } from '../../../../application/actions/ui_loaders';
// import { logReqError } from '../../../ui/utils/functions';

import api from '../../../api';
const apiDesafio = api(process.env.REACT_APP_URL);

export function* fetchRevokeToken(authorization) {
  try {
 
    yield put(loadersActions.changeStatusLoader({ isLoading: true }));
    const { data } = yield call(apiDesafio.post, '/token/revoke', '' , { 
        'Authorization': authorization.payload
     });

    yield put(loadersActions.changeStatusLoader({ isLoading: false }));

    if (data) {
      yield put(revokeTokenAction.fetchRevokeTokenSuccess({ respuestaServicio: data }));
    } else {
      yield put(revokeTokenAction.fetchRevokeTokenError());

    }

  } catch {
      //Errores
    yield all([
      put(revokeTokenAction.fetchRevokeTokenError())
    ]);
  }
}

export function* watchFetchDesafios() {
  yield takeLatest(revokeTokenAction.fetchRevokeToken.type, fetchRevokeToken);
}

export default function* rootSaga() {
  yield spawn(watchFetchDesafios);
}
